// @ts-nocheck
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  Button,
  Checkbox,
  CircularProgress,
  ClickAwayListener,
  useMediaQuery,
} from "@mui/material";
import { Box, Grid, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { CustomInput } from "../../../components/Custom/Input";
import ReusableParentContainer from "../../../components/Custom/ReusableParentContainer";
import {
  getCssVariableHandler,
  getRGBAFromRGBGivenAlphaHandler,
} from "../../../utils/styles/getCssVariables";
import { phoneNumberFormat } from "../../../utils/methods/formatters";
import { AiOutlineDelete } from "react-icons/ai";
import { ALERT_DIALOG } from "../../../store/constants/auth";
import { FaStar } from "react-icons/fa";
import { apiRequest } from "../../../services/apiService";
import { alertDialogAciton } from "../../../store/actions/auth";
import LoadingOverlay from "../../../components/Custom/LoadingOverlay";
import ProfilePic from "../../../assets/images/profile-picture.png";
import { addLogAction } from "../../../store/actions/logs";
import { useSelector } from "react-redux";
import { ClientApproveModal } from "../../../components/Layout/_components/CLientApproveModal";

const Option = ({ option, onClick, selectedClients }) => {
  const isSelected =
    selectedClients?.findIndex?.((contractor) => {
      return contractor?._id === option?._id;
    }) > -1;

  return (
    <>
      <Box
        // {...props}
        sx={{
          width: "100%",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          padding: "8px",
          boxSizing: "border-box",
          background: isSelected
            ? getCssVariableHandler({
                variableName: "--primary-green-rgb",
              })
            : "transparent",
          border: `1px solid ${getCssVariableHandler({
            variableName: "--font-rgb",
          })}`,
          borderRadius: `0.5rem`,
          overflow: "visible",
          cursor: "pointer",
        }}
        className={`autocomplete-option`}
        onClick={onClick}
        data-option={"contractor-search-option"}
      >
        <Box
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <Box
            sx={{
              width: "50px",
              height: "50px",
              borderRadius: "50%",
              overflow: "hidden",
            }}
          >
            <img
              src={option?.profileImage || ProfilePic}
              alt={"Profile Image"}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "0.85rem",
              }}
            >
              <Typography
                variant="span"
                sx={{
                  color: "white",
                  margin: "0",
                }}
              >{`${option?.firstName} ${option?.lastName}`}</Typography>
              <FaStar color="rgb(209, 117, 182)" />
              <Typography
                variant="span"
                sx={{
                  color: "rgb(209, 117, 182)",
                }}
              >
                {option?.companyName}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                gap: "0.5rem",
                fontSize: "0.80rem",
                fontWeight: "200",
              }}
            >
              <Typography variant="span" color={"white"}>
                {`Phone Number: ${phoneNumberFormat(option?.mobile)}`}
              </Typography>

              <Typography variant="span" color={"white"}>
                |
              </Typography>

              <Typography variant="span" color={"white"}>
                {`Email: ${option?.email}`}
              </Typography>
            </Box>
          </Box>
        </Box>
        {/* <div>
          <p
            style={{
              margin: '0',
              opacity: '0.5',
              fontSize: '0.85rem',
              color: "rgb(255, 255, 255, 0.75)"
            }}
          >{option?.positionBrief}</p>
        </div> */}
      </Box>
    </>
  );
};

const AddMoreClients = ({
  handleClose,
  eventId,
  setCount,
  crossList,
  userId: pClient,
  eventData,
}) => {
  // hooks start...
  const [searchClient, setSearchClient] = React.useState("");
  const [clientList, setClientList] = React.useState([]);
  const [selectedClients, setSelectedClients] = React.useState([]);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showClientList, setShowClientList] = React.useState(false);
  const [listState, setListState] = React.useState({
    loading: false,
    error: null,
  });
  const [assignLoading, setAssignLoading] = React.useState(false);
  const [sendEmail, setSendEmail] = useState(true);
  const { userId } = useSelector((state) => state.auth);
  // hooks end...

  async function searchForClient(text) {
    setListState((prev) => {
      return { ...prev, loading: true };
    });

    try {
      const { response, error } = await apiRequest({
        method: "GET",
        url: `getActiveClients?search=${text}`,
        data: null,
        isToken: true,
      });
      if (response?.status === 200) {
        setClientList(response?.data?.data);
      } else if (response?.status !== 200 || error) {
        throw new Error("Failed to fetch clients!");
      }
    } catch (error) {
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error!",
          message: "Failed to fetch clients!",
        }),
      );
    } finally {
      setListState((prev) => {
        return { ...prev, loading: false };
      });
    }
  }

  // React redux hooks start...
  const dispatch = useDispatch();
  // React redux hooks end...

  React.useEffect(() => {
    if (searchClient === "") {
      searchForClient(searchClient);
      return;
    }

    const debounce = setTimeout(() => {
      (async () => {
        searchForClient(searchClient);
      })();
    }, [300]);

    return () => {
      clearTimeout(debounce);
    };
  }, [searchClient]);
  // useEffect end...

  async function addClientsToEvent() {
    // NOTE: do an api call to add those clients to the event
    setAssignLoading(true);
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `assignSecondaryClients`,
      data: {
        secUserIds: [...selectedClients.map((client) => client?._id)],
        sentEmailToClientOnAssign: sendEmail,
      },
      params: {
        eventId,
      },
      isToken: true,
    });

    if (response?.status === 200) {
      setAssignLoading(false);
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Success!",
          message: "Clients added successfully!",
        }),
      );
      // NOTE: add log for each client
      selectedClients?.forEach?.((client) => {
        dispatch(
          addLogAction({
            id: eventId,
            payload: {
              actionById: userId,
              description: `${client?.firstName} ${client?.lastName} added to the event as secondary client`,
              userId: client?._id || client?.id,
            },
          }),
        );
      });
      handleClose();
      setCount((prev) => prev + 1);
    } else if (response?.status !== 200 || error) {
      setAssignLoading(false);
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error!",
          message: error?.response?.data?.message ?? "Failed to add clients!",
        }),
      );
    }
  }

  return (
    <Box
      sx={{
        height: "60vh",
        maxHeight: "70vh",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        // justifyContent: 'center',
        gap: "35px",
        "& > *": {
          width: "100%",
        },
        zIndex: "1300",
      }}
    >
      <Box>
        <Grid item xs={4}>
          <Box
            // className={styles["form-box"]}
            sx={{
              position: "relative",
            }}
          >
            <ClickAwayListener
              onClickAway={() => {
                setShowClientList(false);
              }}
            >
              <Box>
                <CustomInput
                  fullWidth
                  placeholder="Search and Add Clients"
                  name="addclients"
                  autoComplete="off"
                  onChange={(e) => {
                    setSearchClient(e.target.value);
                  }}
                  onFocus={() => {
                    setShowClientList(true);
                  }}
                  value={searchClient}
                  sx={{
                    height: "50px !important",
                  }}
                />

                {showClientList ? (
                  <ReusableParentContainer
                    style={{
                      position: "absolute",
                      height: "fit-content",
                      top: "60px",
                      width: "100% !important",
                      left: "0",
                      background: getCssVariableHandler({
                        variableName: "--bg-theme-rgb",
                      }),
                      padding: "0 !important",
                      zIndex: "10",
                      "@media (max-width: 600px)": {
                        overflowY: "auto !important",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        maxHeight: "300px",
                        overflowY: "auto",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "5px",
                      }}
                      className={"custom-scroll-design"}
                    >
                      {listState?.loading ? (
                        <CircularProgress size={22} />
                      ) : (
                        clientList?.map?.((searchedClient) => {
                          if (
                            crossList?.includes(searchedClient?._id) ||
                            searchedClient?._id === pClient
                          )
                            return null;
                          return (
                            <React.Fragment key={searchedClient?._id}>
                              <Option
                                option={searchedClient}
                                onClick={() => {
                                  const filteredIdx =
                                    selectedClients?.findIndex?.((c) => {
                                      return c?._id === searchedClient?._id;
                                    });

                                  if (filteredIdx < 0) {
                                    setSelectedClients((prev) => {
                                      return [...prev, searchedClient];
                                    });
                                  } else {
                                    dispatch({
                                      type: ALERT_DIALOG,
                                      payload: {
                                        open: true,
                                        title: "Error!",
                                        message:
                                          "You already selected this client!",
                                      },
                                    });
                                  }
                                }}
                                selectedClients={selectedClients}
                              />
                            </React.Fragment>
                          );
                        })
                      )}
                    </Box>
                  </ReusableParentContainer>
                ) : null}
              </Box>
            </ClickAwayListener>
          </Box>
        </Grid>
      </Box>

      <Box
        sx={{
          // paddingRight: '8px',
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: "10px",
          // minHeight: '80%',
          maxHeight: "70%",
          overflowY: "auto",
        }}
        className={"custom-scroll-design"}
      >
        {selectedClients?.map?.((client) => {
          return (
            <React.Fragment key={client?._id}>
              <Box
                sx={{
                  width: "100%",
                  padding: "8px 20px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  color: getCssVariableHandler({
                    variableName: "--font-rgb",
                  }),
                  border: `1px solid ${getRGBAFromRGBGivenAlphaHandler({
                    rgb: getCssVariableHandler({
                      variableName: "--font-rgb",
                    }),
                    alpha: "0.3",
                  })}`,
                  borderRadius: "5px",
                }}
              >
                <Box>
                  <Typography
                    variant="span"
                    sx={{
                      display: "block",
                      fontSize: "20px",
                      fontWeight: "300",
                    }}
                  >
                    {`${client?.firstName} ${client?.lastName}`}
                  </Typography>

                  <Typography
                    variant="span"
                    sx={{
                      display: "block",
                      fontSize: "15px",
                      fontWeight: "200",
                    }}
                  >
                    {client?.companyName}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "25px",
                    textAlign: "right",
                  }}
                >
                  <Box>
                    <Typography>{phoneNumberFormat(client?.mobile)}</Typography>
                    <Typography variant="span">{client?.email}</Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <Button
                      sx={{
                        minWidth: "0",
                        background: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                        padding: "5px",
                        borderRadius: "5px",
                      }}
                      onClick={() => {
                        setSelectedClients((prev) => {
                          return prev.filter((c) => c._id !== client?._id);
                        });
                      }}
                    >
                      <AiOutlineDelete size={28} />
                    </Button>
                  </Box>
                </Box>
              </Box>
            </React.Fragment>
          );
        })}
      </Box>

      <Box sx={{ marginTop: "auto" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "0.5rem",
            width: "100%",
            mt: 3,
          }}
        >
          <Checkbox
            name="sendemail"
            sx={{
              cursor: "pointer",
              padding: "0",
              color: getCssVariableHandler({
                variableName: "--white-rgb",
              }),
              "&.Mui-checked": {
                color: getCssVariableHandler({
                  variableName: "--primary-pink-hex",
                }),
                "& svg": {
                  fill: getCssVariableHandler({
                    variableName: "--primary-pink-hex",
                  }),
                },
              },
            }}
            checked={!!sendEmail}
            onChange={(e) => {
              setSendEmail(e?.target?.checked);
            }}
          />
          <Typography>
            Send an email to client informing account creation
          </Typography>
        </Box>
        <Box
          className="bottom-btn-box"
          sx={{
            width: "100%",
            marginTop: 2,
            alignSelf: "flex-end",
          }}
        >
          <Button
            className="btn-black"
            sx={{
              width: "50%",
              height: "4.25rem",
            }}
            onClick={() => {
              setSelectedClients([]);
              setShowClientList(false);
              handleClose();
            }}
          >
            <Typography className="btn-text">Close</Typography>
          </Button>

          <Button
            className="btn-pink"
            sx={{
              width: "50%",
              height: "4.25rem",
              "&:disabled": {
                background: "#d85ad8 !important",
              },
            }}
            onClick={() => {
              if (selectedClients?.length === 0) {
                dispatch({
                  type: ALERT_DIALOG,
                  payload: {
                    open: true,
                    title: "Error!",
                    message: "Please select at least one client",
                  },
                });
                return;
              }

              const hasUnapprovedClients = selectedClients?.filter(
                (item) => !item?.isApproved,
              )?.length;
              if (hasUnapprovedClients) {
                setShowApproveModal(true);
                return;
              }

              // NOTE: funciton to add client to event
              addClientsToEvent();
            }}
            disabled={listState?.loading || assignLoading}
            // onClick={onClose}
          >
            {listState?.loading || assignLoading ? (
              <CircularProgress size={22} />
            ) : (
              <Typography className="btn-text">Assign Client</Typography>
            )}
          </Button>
        </Box>
      </Box>

      {showApproveModal && (
        <ClientApproveModal
          open={showApproveModal}
          onClose={() => setShowApproveModal(false)}
          row={selectedClients}
          isAssign
          onApproved={() => {
            setShowApproveModal(false);
            addClientsToEvent();
            handleClose();
          }}
        />
      )}
    </Box>
  );
};

export const AddMoreClientTab = ({
  handleClose,
  eventId,
  userId,
  eventData,
}) => {
  // useMediaQuery hook call...
  const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  // useMediaQuery hook call...

  const [showAddMoreClients, setShowAddMoreClients] = React.useState(false);
  const [assignedClients, setAssignedClients] = React.useState([]);
  const [primaryClient, setPrimaryClient] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [count, setCount] = React.useState(0);

  const dispatch = useDispatch();

  React.useEffect(() => {
    // NOTE: fetch the assinged clients
    async function fetchAssignedClients() {
      setIsLoading(true);
      const { response, error } = await apiRequest({
        method: "GET",
        url: `getSecondaryClients`,
        params: {
          eventId,
        },
        isToken: true,
      });

      if (response?.status === 200) {
        setIsLoading(false);
        setAssignedClients(response?.data?.data);
      } else if (response?.status !== 200 || error) {
        setIsLoading(false);
        dispatch(
          alertDialogAciton({
            open: true,
            title: "Error!",
            message: "Failed to fetch secondary clients!",
          }),
        );
      }
    }

    async function fetchPrimaryClient() {
      setIsLoading(true);
      const { response, error } = await apiRequest({
        method: "GET",
        url: `getClient/${userId}`,
        isToken: true,
      });

      if (response?.status === 200) {
        setIsLoading(false);
        setPrimaryClient(response?.data?.data);
      } else if (response?.status !== 200 || error) {
        setIsLoading(false);
        dispatch(
          alertDialogAciton({
            open: true,
            title: "Error!",
            message: "Failed to fetch primary client!",
          }),
        );
      }
    }

    if (userId) {
      fetchAssignedClients();
      fetchPrimaryClient();
    }

    return () => {
      setIsLoading(false);
    };
  }, [count]);

  const closeNestedModal = () => {
    setShowAddMoreClients(false);
  };

  // NOTE: style for modal
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    // width: "auto",
    boxShadow: 24,
    p: 4,
    maxHeight: "98vh",
    minHeight: "50vh",
    // minWidth: "900px",
    borderRadius: "16px",
    padding: "20px",
    border: "2px solid #D175B6",
    backgroundColor: "#000",
    zIndex: 9,
    overflowY: "auto",
  };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        {primaryClient ? (
          <Box
            sx={{
              width: "100%",
              padding: "8px 20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              color: getCssVariableHandler({
                variableName: "--font-rgb",
              }),
              border: `1px solid ${getRGBAFromRGBGivenAlphaHandler({
                rgb: getCssVariableHandler({
                  variableName: "--font-rgb",
                }),
                alpha: "0.3",
              })}`,
              borderRadius: "5px",
              marginTop: "2rem",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
              }}
            >
              <Box
                sx={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "50%",
                  overflow: "hidden",
                }}
              >
                <img
                  src={primaryClient?.profileImage || ProfilePic}
                  alt={"Profile Image"}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </Box>

              <Box>
                <Typography
                  variant="span"
                  sx={{
                    display: "block",
                    fontSize: "20px",
                    fontWeight: "300",
                  }}
                >
                  {`${primaryClient?.firstName} ${primaryClient?.lastName}`}{" "}
                  <span
                    style={{
                      color: getCssVariableHandler({
                        variableName: "--primary-green-shade2-hex",
                      }),
                      fontSize: "15px",
                    }}
                  >
                    Primary Client
                  </span>
                </Typography>

                <Typography
                  variant="span"
                  sx={{
                    display: "block",
                    fontSize: "15px",
                    fontWeight: "200",
                  }}
                >
                  {primaryClient?.companyName}
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "25px",
                textAlign: "right",
              }}
            >
              <Box>
                <Typography>
                  {phoneNumberFormat(primaryClient?.mobile)}
                </Typography>
                <Typography variant="span">{primaryClient?.email}</Typography>
              </Box>
            </Box>
          </Box>
        ) : null}

        {/* NOTE: list of already added clients */}
        <Box
          sx={{
            // paddingRight: '8px',
            height: "40vh",
            display: "flex",
            flexDirection: "column",
            justifyContent:
              assignedClients?.length > 0 ? "flex-start" : "center",
            alignItems: "center",
            gap: "10px",
            // minHeight: '80%',
            maxHeight: "70%",
            overflowY: "auto",
            position: isLoading ? "relative" : "block",
            marginTop: "20px",
          }}
          className={"custom-scroll-design"}
        >
          {assignedClients?.length > 0 && !isLoading ? (
            assignedClients?.map?.((client) => {
              return (
                <React.Fragment key={client?._id}>
                  <Box
                    sx={{
                      width: "100%",
                      padding: "8px 20px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      color: getCssVariableHandler({
                        variableName: "--font-rgb",
                      }),
                      border: `1px solid ${getRGBAFromRGBGivenAlphaHandler({
                        rgb: getCssVariableHandler({
                          variableName: "--font-rgb",
                        }),
                        alpha: "0.3",
                      })}`,
                      borderRadius: "5px",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      <Box
                        sx={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "50%",
                          overflow: "hidden",
                        }}
                      >
                        <img
                          src={client?.profileImage || ProfilePic}
                          alt={"Profile Image"}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </Box>

                      <Box>
                        <Typography
                          variant="span"
                          sx={{
                            display: "block",
                            fontSize: "20px",
                            fontWeight: "300",
                          }}
                        >
                          {`${client?.firstName} ${client?.lastName}`}
                        </Typography>

                        <Typography
                          variant="span"
                          sx={{
                            display: "block",
                            fontSize: "15px",
                            fontWeight: "200",
                          }}
                        >
                          {client?.companyName}
                        </Typography>
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "25px",
                        textAlign: "right",
                      }}
                    >
                      <Box>
                        <Typography>
                          {phoneNumberFormat(client?.mobile)}
                        </Typography>
                        <Typography variant="span">{client?.email}</Typography>
                      </Box>
                    </Box>
                  </Box>
                </React.Fragment>
              );
            })
          ) : (
            <>
              <Typography
                variant="span"
                sx={{
                  fontSize: "1.5rem",
                  color: getCssVariableHandler({
                    variableName: "--white-rgb",
                  }),
                  display: isLoading ? "none" : "block",
                }}
              >
                No secondary clients added yet!
              </Typography>
              {!userId ? (
                <Typography
                  variant="span"
                  sx={{
                    fontSize: "1rem",
                    color: getCssVariableHandler({
                      variableName: "--white-rgb",
                    }),
                    display: isLoading ? "none" : "block",
                    opacity: "0.5",
                  }}
                >
                  Please add primary client first!
                </Typography>
              ) : null}
            </>
          )}
          {isLoading ? <LoadingOverlay open={isLoading} /> : null}
        </Box>
        {/* NOTE: loadin g*/}

        <Box
          className="bottom-btn-box"
          sx={{
            display: "flex",
            flexDirection: isSmallScreen ? "column" : "row",
            width: isSmallScreen ? "100%" : "auto",
          }}
        >
          <Button
            className="btn-black"
            sx={{
              width: isSmallScreen ? "100%" : "auto",
            }}
            onClick={() => {
              handleClose();
            }}
          >
            <Typography className="btn-text">CLOSE</Typography>
          </Button>
          <Button
            sx={{
              width: isSmallScreen ? "100%" : "auto",
              cursor: "pointer",
            }}
            className="btn-pink"
            onClick={() => {
              setShowAddMoreClients(true);
            }}
          >
            <Typography className="btn-text">Add More Clients</Typography>
          </Button>
        </Box>
      </Box>

      {showAddMoreClients && (
        <Box
          sx={{
            ...style,
            width: isMediumScreen ? "95%" : "60%",
            minWidth: isMediumScreen ? "0" : "95%",
            maxWidth: "1200px",
          }}
          className="custom-scroll-design"
        >
          <AddMoreClients
            setCount={setCount}
            eventId={eventId}
            eventData={eventData}
            handleClose={closeNestedModal}
            crossList={assignedClients?.map?.((client) => client?._id)}
            userId={userId}
          />
        </Box>
      )}
    </>
  );
};

Option.propTypes = {
  option: PropTypes.object,
  onClick: PropTypes.func,
  selectedClients: PropTypes.array,
};

AddMoreClients.propTypes = {
  handleClose: PropTypes.func,
  eventId: PropTypes.string,
  setCount: PropTypes.func,
  crossList: PropTypes.array,
  userId: PropTypes.string,
  eventData: PropTypes.object,
};

AddMoreClientTab.propTypes = {
  handleClose: PropTypes.func,
  eventId: PropTypes.string,
  userId: PropTypes.string,
  eventData: PropTypes.object,
};

export default AddMoreClients;